export default __webpack_public_path__ + "static/media/noimg_men.d60b366d.jpg";